<template>
  <div>
    <form action="" class="md-layout" @submit.prevent="submit">
      <div class="md-layout-item">
        <md-card-header>
          <div class="md-title">Cadastrar APK</div>
        </md-card-header>
        <md-card-content>
          <md-field :class="getValidationClass('appName')">
            <label for="appName">AppName</label>
            <md-input id="appName" v-model="form.appName" />
            <span v-if="!$v.form.appName.required" class="md-error"
              >AppName é obrigatório</span
            >
          </md-field>
          <md-field :class="getValidationClass('version')">
            <label for="version">Versão (Ex: 01.01.01)</label>
            <md-input
              id="version"
              v-model="form.version"
              v-mask="['##.##.##']"
            />
            <span v-if="!$v.form.version.required" class="md-error"
              >Versão é obrigatória</span
            >
            <span v-if="!$v.form.version.mustBeValidVersion" class="md-error"
              >Versão inválida</span
            >
          </md-field>

          <md-field :class="getValidationClass('apk')">
            <label for="apk">Apk</label>
            <md-file v-model="form.apk" @md-change="handleApkFile" />
            <span v-if="!$v.form.apk.required" class="md-error"
              >Apk é obrigatório</span
            >
            <span v-if="!$v.form.apk.mustBeApkFile" class="md-error"
              >Arquivo deve ser um APK</span
            >
          </md-field>

          <div class="botoes">
            <md-button
              class="md-raised md-accent"
              @click.prevent="$router.back()"
            >
              Voltar
            </md-button>
            <md-button type="submit" class="md-raised md-primary">
              Salvar
            </md-button>
            <md-progress-spinner
              v-if="loading"
              :md-diameter="40"
              :md-stroke="5"
              md-mode="indeterminate"
            />
          </div>
        </md-card-content>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { helpers, required } from 'vuelidate/lib/validators'

import http from '../../utils/http'

const mustBeValidVersion = helpers.regex('alpha', /^\d+\.\d+\.\d+$/)

const mustBeApkFile = (value) => {
  if (!value) {
    return true
  }

  return value.endsWith('.apk')
}

export default {
  name: 'ApkVersionIndex',
  mixins: [validationMixin],
  data() {
    return {
      form: {
        appName: 'flowautomacao',
        version: '',
        apk: null,
        apkFile: null,
      },
      loading: false,
    }
  },
  validations: {
    form: {
      appName: { required },
      version: { required, mustBeValidVersion },
      apk: { required, mustBeApkFile },
    },
  },
  watch: {
    appName() {
      this.form.version = this.getLatestVersion()
    },
  },
  async beforeMount() {
    this.form.version = await this.getLatestVersion()
  },
  mounted() {},
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    handleApkFile(e) {
      this.form.apkFile = e[0]
    },
    async submit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      if (this.loading) {
        return
      }

      const formData = new FormData()

      formData.append('appName', this.form.appName)
      formData.append('version', this.form.version)
      formData.append('apk', this.form.apkFile)

      this.loading = true
      const response = await http.postForm(`app-version`, formData)
      this.loading = false

      if (response !== null) {
        this.$router.back()
      }
    },
    async getLatestVersion() {
      try {
        const data = await http.get(
          'app-version/latest/' + this.form.appName,
          {},
          false
        )

        return data.version
      } catch (e) {
        return this.form.version
      }
    },
  },
}
</script>

<style scoped></style>
